module.exports = __webpack_public_path__ + "img/43ne.1b56c927.svg";